import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import classNames from "classnames";
import DetailsPanel from "./DetailsPanel";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import styles from "./DetailsPanel.module.scss";
import { useAlert } from "../../contexts/AlertContext";
import { acceptChatRequest, acceptCallRequest, rescheduleCallRequest, endConversationRequest } from "../../services/supportService";
import { checkExpiredConversation } from "../../services/chatServices";
import ImagePreviewLightbox from "../ImagePreviewLightbox";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const formatDateTimeToString = (dateObjTmp) => {
  if (!dateObjTmp) return "";
  return moment(dateObjTmp).format("DD-MM-YYYY, hh:mm A");
};

function evaluateSessionTiming(startDateUTC, endDateUTC, isChat) {
  if (isChat === true) {
    return {
      isFutureSession: false,
      isPastSession: false,
      isSessionInWhile: false,
      isCurrentSession: false
    };
  }

  const now = moment();
  const startDate = moment(startDateUTC);
  const endDate = moment(endDateUTC);

  const isFutureSession = startDate.isAfter(now);
  const isPastSession = endDate.isBefore(now);

  // Checks if now is between start and end (inclusive)
  const isCurrentSession = now.isBetween(startDate, endDate, null, '[]');

  const diffInMillis = startDate.diff(now);
  // 10 minutes in ms = 600000
  const isSessionInWhile = diffInMillis > 0 && diffInMillis <= 600000;

  return {
    isFutureSession,
    isPastSession,
    isSessionInWhile,
    isCurrentSession
  };
}

const formatDateForInputLocal = (dateStr) => {
  if (!dateStr) return "";
  return moment(dateStr).format("YYYY-MM-DD");
};

const formatTimeForInputLocal = (dateStr) => {
  if (!dateStr) return "";
  return moment(dateStr).format("HH:mm");
};

const getHourMinuteDiffString = (date1, date2) => {
  const start = moment(date1);
  const end = moment(date2);
  const duration = moment.duration(end.diff(start));
  const hours = Math.abs(Math.floor(duration.asHours()));
  const minutes = Math.abs(duration.minutes());

  if (hours === 0) {
    return `${minutes}m`;
  } else if (minutes === 0) {
    return `${hours}h`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};

const getAddress = (userInfo) => {
  const addressArr = [];
  if (userInfo?.createdBy?.address) {
    addressArr.push(userInfo?.createdBy?.address);
  }
  if (userInfo?.createdBy?.city) {
    addressArr.push(userInfo?.createdBy?.city);
  }
  if (userInfo?.createdBy?.state?.name) {
    addressArr.push(userInfo?.createdBy?.state?.name);
  }
  if (userInfo?.createdBy?.country?.code) {
    addressArr.push(userInfo?.createdBy?.country?.code);
  }
  if (userInfo?.createdBy?.zipCode) {
    addressArr.push(userInfo?.createdBy?.zipCode);
  }
  return addressArr.join(", ");
};

const identifyUser = (data) => {
  let userMeta = { label: "", image: "", role: "" };
  if (data?.createdBy?.roleId == 3) {
    if (data?.createdBy?.createdBy === data.admin.id) {
      userMeta = {
        label: "Expert",
        role: "expert",
        image: "/images/user-circle-check-green.svg",
      };
    } else {
      userMeta = {
        label: "External Expert",
        role: "external_expert",
        image: "/images/user-circle-dashed-red.svg",
      };
    }
  } else if (data?.createdBy?.roleId == 5) {

    userMeta = {
      label: "Contacts",
      role: "contact",
      image: "/images/user-circle-gear-blue.svg",
    };

  } else if (data?.createdBy?.roleId == 2) {
    if (data?.createdBy?.createdBy === data?.createdBy?.id) {
      userMeta = {
        label: "User",
        role: "internal_user",
        image: "/images/user-circle-gear-blue.svg",
      };
    } else {
      userMeta = {
        label: "User",
        role: "external_user",
        image: "/images/user-circle-yellow.svg"
      };
    }
  }
  return userMeta;
};

const sessionStatusIdentify = (session) => {
  const now = moment();
  const endDate = moment(session?.endTime);

  if (session?.conversationStatus == "Assigned") {
    if (endDate.isAfter(now)) {
      return { "type": "confirmed", "text": "Confirmed" }
    } else {
      return { "type": "expired", "text": "Confirmed" }
    }
  } else if (session?.conversationStatus == "Pending") {
    if (endDate.isBefore(now)) {
      return { "type": "expired", "text": "Expired" }
    } else {
      return { "type": "pending", "text": "Pending" }
    }
  }
}

const InboxDetailsPanel = ({ onClose, item, inboxList, loggedInUser, setInboxList, onSidebarClose, getInboxData }) => {
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [singleInboxItem, setSingleInboxItem] = useState(null);
  const [showActionButtons, setShowActionButtons] = useState(null);
  const [timeOptions, setTimeOptions] = useState([]);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const startTime = item?.startTime;
  const endTime = item?.endTime;
  const userData = identifyUser(item);
  const sessionStatus = sessionStatusIdentify(item);
  const chatType = (item?.conversationType?.includes("chat")) ? true : false
  const [showModalCancel, setShowModalCancel] = useState(null);
  const [requestDate, setRequestDate] = useState("");
  const [startTimeReschedule, setStartTimeReschedule] = useState("");
  const [endTimeReschedule, setEndTimeReschedule] = useState("");
  const [formErrors, setFormErrors] = useState({});
  console.log("loggedInUserloggedInUser", loggedInUser);
  const [rescheduleRequest, setRescheduleRequest] = useState({
    "startTime": null,
    "endTime": null
  });

  const sessionTimeStatus = evaluateSessionTiming(startTime, endTime, chatType)
  console.log("evaluateSessionTiming", sessionTimeStatus)
  const isSupprtRequest = item?.conversationType?.includes("support")

  const removeConversationById = (idToRemove) => {
    setInboxList(prev => {
      // Optionally, find the object first if you need to do something with it
      const removedItem = prev.find(item => item.id === idToRemove);

      // Now remove it from the list
      const updatedList = prev.filter(item => item.id !== idToRemove);

      // Optional: console log or handle the removed item
      console.log('Removed:', removedItem);

      return updatedList;
    });
  };

  useEffect(() => {
    if (!requestDate) return;

    const generateTimeOptions = () => {
      const times = [];
      const now = moment();
      const selectedDate = moment(requestDate, "YYYY-MM-DD");
      const isToday = selectedDate.isSame(now, 'day');

      let cursor = moment(requestDate).startOf('day');
      const endOfDay = moment(requestDate).endOf('day');

      // Loop through 24 hours in 15 min intervals
      while (cursor.isBefore(endOfDay)) {
        // If today, ensure time is at least 15 mins from now
        if (!isToday || cursor.isAfter(moment().add(15, 'minutes'))) {
          times.push({
            value: cursor.format("HH:mm"),
            label: cursor.format("h:mm A")
          });
        }
        cursor.add(15, 'minutes');
      }
      return times;
    };

    setTimeOptions(generateTimeOptions());
  }, [requestDate]);


  const rescheduleCall1 = async () => {
    try {
      const chatRequestData = await acceptChatRequest(rescheduleRequest);
      // removeConversationById(id)
      onSidebarClose()
      showAlert({
        title: "Inbox Notification",
        message: chatRequestData?.message ?? "something went wrong",
        variant: "success",
      });
    } catch (error) {
      showAlert({
        title: "Inbox Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  }

  const validateReschedule = () => {
    const errors = {};

    if (!requestDate) errors.requestDate = "Request date is required";
    if (!startTimeReschedule) errors.startTimeReschedule = "Start time is required";
    if (!endTimeReschedule) errors.endTimeReschedule = "End time is required";

    if (requestDate && startTimeReschedule && endTimeReschedule) {
      const start = moment(`${requestDate} ${startTimeReschedule}`, "YYYY-MM-DD HH:mm");
      const end = moment(`${requestDate} ${endTimeReschedule}`, "YYYY-MM-DD HH:mm");
      const now = moment();

      // 1. End time must be after start time
      if (end.isSameOrBefore(start)) {
        errors.endTimeReschedule = "End time must be after start time";
      }

      // 2. Request date cannot be in the past (allow today)
      if (moment(requestDate).isBefore(now, 'day')) {
        errors.requestDate = "Date cannot be in the past";
      }

      // 3. If today, start must be 15 min from now
      // We add 14 minutes to allow the 15th minute to be valid
      if (start.isBefore(now.add(14, 'minutes'))) {
        errors.startTimeReschedule = "Start time must be at least 15 minutes from now";
      }

      // 4. Duration must be at least 15 minutes
      const duration = moment.duration(end.diff(start)).asMinutes();
      if (duration < 15) {
        errors.endTimeReschedule = "Minimum duration is 15 minutes";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const rescheduleCall = async () => {
    if (!validateReschedule()) return;

    const startDateTime = moment(`${requestDate} ${startTimeReschedule}`, "YYYY-MM-DD HH:mm").toISOString();
    const endDateTime = moment(`${requestDate} ${endTimeReschedule}`, "YYYY-MM-DD HH:mm").toISOString();

    try {
      // Call your API here
      const payload = {
        sessionId: singleInboxItem?.id,
        startTime: startDateTime,
        endTime: endDateTime,
      };
      console.log("payload", payload)
      const chatRequestData = await rescheduleCallRequest(singleInboxItem?.id, payload);
      getInboxData();
      // Example using fetch:
      // await fetch("/api/reschedule-session", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(payload),
      // });

      // On success
      onSidebarClose();
      setRescheduleModal(false);
    } catch (error) {
      console.error("Failed to reschedule:", error);
      // Show error to user if needed
    }
  };


  const acceptConversation = async (id, isChatType) => {

    if (isChatType) {
      try {
        const chatRequestData = await acceptChatRequest(id);
        removeConversationById(id)
        navigate("/chat", { state: { singleInboxItem: chatRequestData.data } })
        onSidebarClose()
        showAlert({
          title: "Inbox Notification",
          message: chatRequestData?.message ?? "something went wrong",
          variant: "success",
        });
      } catch (error) {
        showAlert({
          title: "Inbox Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
      }
    } else {
      try {
        const callRequestData = await acceptCallRequest(id);
        removeConversationById(id)
        onSidebarClose()
        showAlert({
          title: "Inbox Notification",
          message: callRequestData?.message ?? "something went wrong",
          variant: "success",
        });
      } catch (error) {
        showAlert({
          title: "Inbox Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
      }
    }
  }

  const chatActionHandle = async (id) => {

    try {
      const chatRequestData = await checkExpiredConversation(id);
      if (chatRequestData) {
        removeConversationById(id)
        navigate("/chat", { state: { singleInboxItem: chatRequestData.data } })
        removeConversationById(id)
        onSidebarClose();
        showAlert({
          title: "Inbox Notification",
          message: chatRequestData?.message ?? "something went wrong",
          variant: "success",
        });
      }

    } catch (error) {
      removeConversationById(id);
      onSidebarClose();
      showAlert({
        title: "Inbox Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  }

  const cancelChatRequest = async (id) => {

    const data = {
      "action": "cancel_support"
    }
    try {
      const callRequestData = await endConversationRequest(id, data);
      removeConversationById(id);
      setShowModalCancel(false);
      onSidebarClose();
      showAlert({
        title: "Inbox Notification",
        message: callRequestData?.message ?? "something went wrong",
        variant: "success",
      });
    } catch (error) {
      showAlert({
        title: "Inbox Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }

  }

  const renderActionButtons = () => {
    if (!userData || !sessionStatus || !sessionTimeStatus) return null;

    const buttons = [];

    const isClient = userData.role === "contact";
    const isExternalExpert = userData.role === "external_expert";
    const isExpert = userData.role === "expert";
    const { isSessionInWhile, isCurrentSession, isPastSession, isFutureSession } = sessionTimeStatus;
    const { type: sessionType } = sessionStatus;

    const ButtonAccept = (
      <Button
        variant="primary"
        onClick={() => acceptConversation(singleInboxItem?.id, chatType)}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image
          src="/images/check-white.svg"
          width={20}
          height={20}
          alt="Check Icon"
        />{" "}
        Accept
      </Button>
    );

    const ButtonChat = (
      <Button
        variant="primary"
        onClick={() => acceptConversation(singleInboxItem?.id, chatType)}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image
          src="/images/chat-circle-text-white.svg"
          width={20}
          height={20}
          alt="Chat Circle Text Icon"
        />{" "}
        Chat
      </Button>
    );

    const ButtonChatExpired = (
      <Button
        variant="primary"
        onClick={() => chatActionHandle(singleInboxItem?.id)}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image
          src="/images/chat-circle-text-white.svg"
          width={20}
          height={20}
          alt="Chat Circle Text Icon"
        />{" "}
        Chat
      </Button>
    );

    const ButtonReschedule = (
      <Button
        variant="gray"
        onClick={() => {
          setRequestDate(formatDateForInputLocal(singleInboxItem?.startTime));
          setStartTimeReschedule(formatTimeForInputLocal(singleInboxItem?.startTime));
          setEndTimeReschedule(formatTimeForInputLocal(singleInboxItem?.endTime));
          setRescheduleModal(true);
        }}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image
          src="/images/calendar-dots-primary.svg"
          width={20}
          height={20}
          alt="Calendar Dots Icon"
        />{" "}
        Reschedule
      </Button>
    );

    const ButtonCancel = (
      <Button variant="outline-secondary" className="btn-md" onClick={() => setShowModalCancel(singleInboxItem?.id)}>
        Cancel
      </Button>
    );

    if (chatType) {
      if (singleInboxItem?.createdBy?.id === loggedInUser?.user?.id) {
        return <>{ButtonCancel}</>;
      } else {
        return <>{ButtonAccept}</>;
      }

    }


    if (isClient) {

      if (sessionType === "expired" || isPastSession) {
        return <>{ButtonChatExpired}</>;
      } else if (isFutureSession) {
        return <>{ButtonAccept}{ButtonReschedule}</>;
      }
    }

    if (isExpert) {

      if (sessionType === "expired" || isPastSession) {
        return <>{ButtonChatExpired}{ButtonReschedule}{ButtonCancel}</>;
      } else if (isFutureSession) {
        return <>{ButtonAccept}{ButtonReschedule}</>;
      }
    }

    if (isExternalExpert) {

      console.log("isExpert " + " isSessionInWhile " + isSessionInWhile + " sessionType " + sessionType)

      if (sessionType === "expired" || isPastSession) {
        return <>{ButtonChatExpired}</>;
        // return <>{ButtonChatExpired}{ButtonReschedule}{ButtonCancel}</>;
      } else if (isFutureSession) {
        return <>{ButtonAccept}{ButtonReschedule}</>;
      }
    }

    return null;
  };


  useEffect(() => {
    setSingleInboxItem(item);
  }, [item]);

  console.log("Krunal", singleInboxItem);

  return (
    <>
      <DetailsPanel isOpen={!!item}>
        <div
          className={classNames(
            styles["detail-panel-head"],
            "d-flex align-items-center justify-content-between gap-3"
          )}
        >
          <h2 className="h5 fw-semibold mb-0">Request Information</h2>
          <button type="button" className="btn-reset" onClick={onSidebarClose}>
            <Image src="/images/btn-close-square.svg" />
          </button>
        </div>
        <div className={styles["detail-panel-body"]}>
          <div className="d-flex align-items-center gap-3">
            {singleInboxItem?.createdBy?.profilePic ? (
              <ImagePreviewLightbox className="user-avtar user-avtar-48" src={singleInboxItem?.createdBy?.profilePic}>
                <Image
                  width="48"
                  height="48"
                  className="bg-gray-100 cursor-pointer object-fit-cover rounded-circle"
                  src={singleInboxItem?.createdBy?.profilePic}
                  alt="User Avatar"
                />
              </ImagePreviewLightbox>
            ) : (
              <Image
                width={48}
                height={48}
                alt="User Avatar"
                className="object-fit-cover rounded-circle"
                src={`https://ui-avatars.com/api/?name=${singleInboxItem?.createdBy?.firstName}+${singleInboxItem?.createdBy?.lastName}&background=007bff&color=fff&size=100`}
              />
            )}
            <div>
              <h3 className="fs-20 fw-semibold mb-0">{singleInboxItem?.createdBy?.firstName || ''} {singleInboxItem?.createdBy?.lastName || ''}</h3>
              <ul className="d-flex flex-wrap align-items-center gap-1 list-unstyled mb-0">
                <li className="fs-14">{singleInboxItem?.createdBy?.email || ''}</li>
                <li className="dot-separator md"></li>
                <li className="fs-14">+{singleInboxItem?.createdBy?.countryCode || ''}{singleInboxItem?.createdBy?.phoneNo || ''}</li>
              </ul>
            </div>
          </div>
          {singleInboxItem?.conversationType != 'internal call' &&
            <div className="border-top pt-4 mt-4">
              <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                Company Details
              </h4>

              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-1">
                  Company Name
                </span>
                <div className="d-flex align-items-center gap-2">
                  {singleInboxItem?.createdBy?.companyName || ""}
                </div>
              </div>
              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Company Address
                </span>
                <p className="mb-0">{getAddress(singleInboxItem)}</p>
              </div>
            </div>}
          <div className="border-top pt-4 mt-4">
            <h4 className="text-blue-800 fs-7 fw-medium mb-4">
              Session Details
            </h4>

            <div className="mb-3">
              <span className="fs-14 text-gray-500 d-block mb-2">
                Channel
              </span>
              <ul className="d-flex flex-wrap align-content-center gap-2 list-unstyled mb-0">
                {singleInboxItem?.conversationType?.includes("chat") ? (
                  <li className="session-type-badge d-flex align-items-center gap-2">
                    <Image
                      src="/images/chats-circle.svg"
                      width={20}
                      height={20}
                      alt="Chat Circle Icon"
                    />{" "}
                    Chat
                  </li>
                ) : (
                  <li className="session-type-badge d-flex align-items-center gap-2">
                    <Image
                      src="/images/video-camera-blue.svg"
                      width={20}
                      height={20}
                      alt="Video Camera Blue Icon"
                    />{" "}
                    Video
                  </li>
                )}
              </ul>
            </div>
            <div className="mb-3">
              <span className="fs-14 text-gray-500 d-block mb-2">
                {singleInboxItem?.conversationType?.includes("chat") ? "Session Time" : "Session Timeline"}
              </span>
              <p className="mb-0">
                {formatDateTimeToString(
                  singleInboxItem?.startTime || singleInboxItem?.createdAt
                )}
                {singleInboxItem?.endTime &&
                  " - " +
                  formatDateTimeToString(singleInboxItem?.endTime)}
              </p>
            </div>

            {singleInboxItem?.startTime && singleInboxItem?.endTime && (
              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Total Session Duration
                </span>
                <p className="mb-0">
                  {getHourMinuteDiffString(
                    singleInboxItem.endTime,
                    singleInboxItem.startTime
                  )}
                </p>
              </div>
            )}
          </div>
          {singleInboxItem?.expertise?.name && <div className="border-top pt-4 mt-4">
            <h4 className="text-blue-800 fs-7 fw-medium mb-4">
              Expertise Details
            </h4>
            <div className="mb-3">
              <span className="fs-14 text-gray-500 d-block mb-1">
                Expertise
              </span>
              <div className="d-flex align-items-center gap-2">
                {singleInboxItem?.expertise?.name || ""}
              </div>
              {console.log('singleInboxItem-------------------------------------------->', singleInboxItem)}
            </div>

          </div>}
        </div>

        <div
          className={classNames(
            styles["detail-panel-footer"],
            "d-flex flex-wrap align-items-center gap-2"
          )}
        >

          {renderActionButtons()}

        </div>

      </DetailsPanel>
      <Modal
        className="user-detail-modal"
        size="xl"
        show={rescheduleModal}
        onHide={() => setRescheduleModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="h-100 p-0">
          <div className="h-100 d-flex align-items-start gap-3">
            <div className="user-modal-session-details">
              <div className="border-bottom border-grey-200 p-4">
                <h2 class="fs-20 fw-semibold text-gray-700 mb-0">
                  Session Information
                </h2>
              </div>
              <div className="p-4">
                <div className="d-flex align-items-center gap-3">
                  {singleInboxItem?.createdBy?.profilePic ? <Image
                    width="48"
                    height="48"
                    alt="User Avatar"
                    className="object-fit-cover rounded-circle"
                    src={singleInboxItem?.createdBy?.profilePic}
                  /> : <Image
                    width={48}
                    height={48}
                    alt="User Avatar"
                    className="object-fit-cover rounded-circle"
                    src={`https://ui-avatars.com/api/?name=${singleInboxItem?.createdBy?.firstName}+${singleInboxItem?.createdBy?.lastName}&background=007bff&color=fff&size=100`}
                  />}
                  <div>
                    <h3 className="fs-20 fw-semibold mb-0">
                      {singleInboxItem?.createdBy?.firstName || ""}{" "}
                      {singleInboxItem?.createdBy?.lastName || ""}
                    </h3>
                    <ul className="d-flex flex-wrap align-items-center gap-1 list-unstyled mb-0">
                      <li className="fs-14">
                        {singleInboxItem?.createdBy?.email || ""}
                      </li>
                      <li className="dot-separator md"></li>
                      <li className="fs-14">
                        +{singleInboxItem?.createdBy?.countryCode || ""}{" "}
                        {singleInboxItem?.createdBy?.phoneNo || ""}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="border-top pt-4 mt-4">
                  <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                    Company Details
                  </h4>

                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Company Name
                    </span>
                    <div className="d-flex align-items-center gap-2">
                      {singleInboxItem?.createdBy?.companyName || ""}
                    </div>
                  </div>
                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Company Address
                    </span>
                    <p className="mb-0">{getAddress(singleInboxItem)}</p>
                  </div>
                </div>

                <div className="border-top pt-4 mt-4">
                  <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                    Session Details
                  </h4>

                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Channel
                    </span>
                    <ul className="d-flex flex-wrap align-content-center gap-2 list-unstyled mb-0">
                      {singleInboxItem?.conversationType?.includes("chat") ? (
                        <li className="session-type-badge d-flex align-items-center gap-2">
                          <Image
                            src="/images/chats-circle.svg"
                            width={20}
                            height={20}
                            alt="Chat Circle Icon"
                          />{" "}
                          Chat
                        </li>
                      ) : (
                        <li className="session-type-badge d-flex align-items-center gap-2">
                          <Image
                            src="/images/video-camera-blue.svg"
                            width={20}
                            height={20}
                            alt="Video Camera Blue Icon"
                          />{" "}
                          Video
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Session Timeline
                    </span>
                    <p className="mb-0">
                      {formatDateTimeToString(
                        singleInboxItem?.startTime || singleInboxItem?.createdAt
                      )}
                      {singleInboxItem?.endTime &&
                        " - " +
                        formatDateTimeToString(singleInboxItem?.endTime)}
                    </p>
                  </div>

                  {singleInboxItem?.startTime && singleInboxItem?.endTime && (
                    <div className="mb-3">
                      <span className="fs-14 text-gray-500 d-block mb-2">
                        Total Session Duration
                      </span>
                      <p className="mb-0">
                        {getHourMinuteDiffString(
                          singleInboxItem.endTime,
                          singleInboxItem.startTime
                        )}
                      </p>
                    </div>
                  )}
                </div>

                {singleInboxItem?.expertise?.name && <div className="border-top pt-4 mt-4">
                  <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                    Expert Details
                  </h4>
                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Expertise
                    </span>
                    <p className="mb-0">{singleInboxItem?.expertise?.name}</p>
                  </div>
                </div>}
              </div>
            </div>

            <div className="user-modal-session-info d-flex flex-column">
              <div className="border-bottom border-grey-200 p-4">
                <h2 class="fs-20 fw-semibold text-gray-700 mb-0">Reschedule</h2>
              </div>
              <div className="flex-grow-1 p-3">
                <Form.Group controlId="request-date" className="position-relative mb-3">
                  <Form.Label>Request Date</Form.Label>
                  <div className="form-control-date">
                    <Form.Control
                      type="date"
                      name="request-date"
                      min={new Date().toISOString().split('T')[0]}
                      value={requestDate}
                      onChange={(e) => setRequestDate(e.target.value)}
                      className={`${formErrors.requestDate ? "is-invalid" : ""}`}
                    />
                    {formErrors.requestDate && <div className="invalid-feedback">{formErrors.requestDate}</div>}
                  </div>
                </Form.Group>

                {/* START TIME */}
                <Form.Group controlId="start-time" className="position-relative mb-3">
                  <Form.Label>Start Time</Form.Label>
                  <Form.Select
                    name="start-time"
                    value={startTimeReschedule}
                    onChange={(e) => setStartTimeReschedule(e.target.value)}
                    className={`form-control-time ${formErrors.startTimeReschedule ? "is-invalid" : ""}`}
                  >

                    {timeOptions.map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  {formErrors.startTimeReschedule && <div className="invalid-feedback">{formErrors.startTimeReschedule}</div>}

                </Form.Group>

                {/* END TIME */}
                <Form.Group controlId="end-time" className="position-relative mb-3">
                  <Form.Label>End Time</Form.Label>
                  <Form.Select
                    name="end-time"
                    value={endTimeReschedule}
                    onChange={(e) => setEndTimeReschedule(e.target.value)}
                    className={`form-control-time ${formErrors.endTimeReschedule ? "is-invalid" : ""}`}
                  >
                    {timeOptions.map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  {formErrors.endTimeReschedule && <div className="invalid-feedback">{formErrors.endTimeReschedule}</div>}

                </Form.Group>
              </div>
              <div className="d-flex align-items-center gap-2 border-top p-3">
                <Button variant="primary" className="btn-md" onClick={() => rescheduleCall()}>
                  Update & Save
                </Button>
                <Button
                  variant="outline-secondary"
                  className="btn-md"
                  onClick={() => setRescheduleModal(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Cancel Pending Request Offcanvas */}
      <Modal
        className="info-modal"
        show={showModalCancel}
        onHide={() => setShowModalCancel(null)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/x-badge-red.svg" alt="X Badge" />
            <h2 className="fs-30 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to cancel this chat request?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button onClick={() => cancelChatRequest(showModalCancel)} variant="primary" className="btn w-100 mt-5">
                Yes, Cancel It
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModalCancel(null)}
              >
                No, Not Yet!
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InboxDetailsPanel;
